import { useParams } from "react-router-dom";
import { ComingSoon } from "@/apps/_shared/ComingSoon";
import { COMING_SOON_TILES } from "@/lib/dashboard";

export function ComingSoonPage() {
  const { slug } = useParams<{ slug: string }>();
  const meta = slug ? COMING_SOON_TILES[slug] : undefined;

  return (
    <ComingSoon
      title={meta?.title ?? "Coming soon"}
      description={
        meta?.description ??
        "This module is not available yet. Check back soon for updates."
      }
    />
  );
}
